"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function valueFromType(type) {
    switch (type) {
        case 'number':
            return 0;
        case 'string':
            return '';
        case 'boolean':
            return false;
        case 'array':
            return [];
        case 'object':
            return {};
        default:
            return null;
    }
}
exports.default = valueFromType;
